import { AxiosClient } from "../../utils/axios";
import { logError } from "../../utils/logError";
export const state = () => ({
  chatLoading: false,
  qnaLoading: false,
  token: "",
  chatRoomSelected: {
    room_id: "",
    name: "",
    avatar: "",
    current_pro_id: "",
  },
  chatRoomTemporary: {
    name: "",
    avatar: "",
    fanpage_id: "",
  },
  profile: {},
  list_room: [],
  toxic_list: [],

  badWords:null
});

export const mutations = {
  SET_CHAT_LOADING(state, payload) {
    state.chatLoading = payload;
  },


  SET_BADWORDS(state, payload) {
    state.badWords = payload;
  },
  SET_QNA_LOADING(state, payload) {
    state.qnaLoading = payload;
  },
  SET_CHAT_ROOM_SELECTED(state, payload) {
    state.chatRoomSelected = payload;
    localStorage.setItem("chatRoomSelected", JSON.stringify(payload));
  },
  SET_CHAT_ROOM_TEMPORARY(state, payload) {
    state.chatRoomTemporary = payload;
  },
  SET_TOKEN(state, payload) {
    state.token = payload;
  },
  SET_LIST_ROOM(state, payload) {
    state.list_room = payload;
  },
  SET_PROFILE(state, payload) {
    state.profile = payload;
  },
  SET_TOXIC_LIST(state, payload) {
    state.toxic_list = payload;
  },
};

export const actions = {
  async sendQuestionToNewsPaper({ commit,rootState }, questionData) {
    try {
      
      commit("SET_QNA_LOADING", true);
      const res = await AxiosClient.post(
        `/eduzone/api/chat/send_question_to_newspaper`,
        questionData
      );

      const { data } = res.data;
      commit("SET_QNA_LOADING", false);
      return data;
    } catch (e) {
      commit("SET_QNA_LOADING", false);
      
      logError(e,'sendQuestionToNewsPaper on store')
    }
  },
  async getListRoom({ commit, state, rootState },payload) {
    try {
      const { userRole } = rootState.SchoolAccount;


      const chatToken = state.token;
   
      if(payload==true){
        AxiosClient.defaults.baseURL = 'http://localhost:3000'
      }
      let type = userRole?.length>0 ? "fanpage" : "user"
      if(typeof payload == 'string' && payload=='user'){
        type = 'user'
      }
      
      if (Object.keys(state.profile).length > 0) {
        const listRoomResponse = await AxiosClient.get(
          `/eduzone/api/chat/get_list_room?get_by=${type}`,
          {
            headers: {
              Authorization: `Bearer ${chatToken}`,
            },
          }
        );
     
        if (
          listRoomResponse.data.data.code == 200 &&
          listRoomResponse.data.data.data &&
          listRoomResponse.data.data.data.length > 0
        ) {
        
          const listRoomAfterSoft = listRoomResponse.data.data.data.sort((a, b) => b?.new_message?.created_at || 0 - a?.new_message?.created_at || 0);
       
       
          commit("SET_LIST_ROOM", listRoomAfterSoft);
        }
      }
    } catch (error) {
      logError(error,'getListRoom on store')
    }
  },
  async getProfile({ commit, state, rootState },payload) {
    try {
      const user = rootState.userInfo.info;
  
      if(!user) return '';
      const chatToken = state.token;
     
     
      if(payload==true){
        AxiosClient.defaults.baseURL = 'http://localhost:3000'
      }
      const response = await AxiosClient.get("/api/chat/me", {
        headers: {
          Authorization: `Bearer ${chatToken}`,
        },
      });
 
      //403 mean profile not found -> call api create profile

      if (
        response.data?.code == 403 ||
        Object.keys(response.data?.data)?.length === 0
      ) {

        let name = '';
  
       
        if(user.email && user.email.length>0){
          name = user.email
      
        }else if(user.name && user.name>0){
          name= user.name
        }else if(user.phone && user.phone.length>0){
          name= `${user.phone}`
        }
 
        const body = {
          name,
          fanpage_member_ids: [user.id],
        };

        const createProfileResponse = await AxiosClient.post(
          "/eduzone/api/chat/create_profile",
          body,
          {
            headers: {
              Authorization: `Bearer ${chatToken}`,
            },
          }
        );
        if (createProfileResponse?.data?.data) {
          commit("SET_PROFILE", createProfileResponse?.data?.data?.data);
          return createProfileResponse?.data?.data
        }else{
          return "createProfileResponse not have data"
        }
      }
      //found profile
      else {
        if (response?.data?.data) {
          commit("SET_PROFILE", response?.data?.data);
        }
        return response.data.data
      }
    } catch (error) {
    //  logError(error,`getProfile on store`)
   
    }
  },
  async getToxicList({ commit, state, rootState,redirect },payload) {
    try {
      if(payload){
        AxiosClient.defaults.baseURL = 'http://localhost:3000'
      }
      const response = await AxiosClient.get("/eduzone/api/chat/get_toxic_list");
      if (response.data?.data?.data) {
      
        commit("SET_TOXIC_LIST", response.data?.data?.data);
      }
      
    } catch (error) {
      
      if(error.response.status==301){
        
      }
      logError(error,'getToxicList on store')
    }
  },
};
